import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { CHART_TYPES } from '../services/chartTypeUtils';

export default function ChartTypeToggle({ value, onChange, disabled, busy }) {
  function handle(event, next) {
    if (next && next !== value) {
      onChange(next);
    }
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <ToggleButtonGroup size="small" exclusive value={value} onChange={handle} disabled={disabled || busy}>
        {CHART_TYPES.map(({ value: v, label, Icon }) => (
          <ToggleButton key={v} value={v} sx={{ textTransform: 'none', px: 1.25 }}>
            <Icon fontSize="small" sx={{ mr: 0.5 }} />
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {busy && <CircularProgress size={16} />}
    </Box>
  );
}
